import { Injectable } from '@angular/core';

import { CurrencyModel }  from '../models/currency';
import { SessionService } from '../../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  constructor (
    private sessionService: SessionService
  ) {}

  getInfo () : CurrencyModel {
    const session = this.sessionService.base();

    return {
      price_includes_tax: session.company_settings.price_includes_tax,
      purchases_tax_rate: session.company_settings.purchases_tax_rate,
      round_total       : session.company_settings.round_total,
      sales_tax_rate    : session.company_settings.sales_tax_rate,
      symbol            : session.country_settings.currency,
      tax_name          : session.company_settings.tax_name || 'GST'
    };
  }
}
